import React from 'react';
export const ComparisonTable: React.FC = () => {
  const comparisons = [{
    situation: 'No sabés si tu tierra sirve para construir',
    without: 'Pagás un geólogo o improvisás',
    with: 'Test del Frasco. 24 horas. Listo.'
  }, {
    situation: 'Calculás materiales a ojo y sobrás o faltás',
    without: 'Fletes de emergencia. Pérdida de plata',
    with: 'Eco-Estimator. Comprás exacto.'
  }, {
    situation: 'El municipio rechaza tu proyecto de tierra',
    without: 'Meses de burocracia o abandono',
    with: 'Guía de Legalidad. Vocabulario técnico.'
  }, {
    situation: 'Las paredes quedan rugosas y poco prolijas',
    without: 'Casa de aspecto "rancho precario"',
    with: 'Tadelakt y Bruñido. Calidad de revista.'
  }, {
    situation: 'El calor o el frío te arruinan la obra',
    without: 'Comprás equipos caros de calefacción',
    with: 'Techo Vivo + diseño bioclimático. $0.'
  }, {
    situation: 'La procrastinación detiene el proyecto',
    without: 'Terreno vacío. Mismo ciclo. Otro año.',
    with: 'Plan 30 días. Un paso cada día.'
  }];
  return <section className="bg-white py-20 px-5 text-center" data-id="element-59">
      <h2 className="text-[clamp(22px,3.5vw,38px)] text-[#1A1A1A] mb-2.5" data-id="element-60">
        ¿Cuánto cuesta NO tenerlo?
      </h2>
      <p className="text-[15px] text-[#777] font-sans mb-10" data-id="element-61">
        El verdadero costo no es el precio del pack. Es seguir sin él.
      </p>

      <div className="max-w-[800px] mx-auto mb-[30px] rounded-2xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.08)]" data-id="element-62">
        <div className="grid grid-cols-[1.5fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr] bg-gradient-to-br from-green-brand to-green-dark text-white py-4 px-5 font-sans font-bold text-sm text-center" data-id="element-63">
          <div className="text-left" data-id="element-64">Situación en la Obra</div>
          <div data-id="element-65">❌ Sin Mega Pack</div>
          <div data-id="element-66">✅ Con Mega Pack</div>
        </div>

        {comparisons.map((item, index) => <div key={index} className={`grid grid-cols-[1.5fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr] py-3.5 px-5 border-b border-[#F0F0F0] items-center font-sans text-sm ${index % 2 === 0 ? 'bg-white' : 'bg-[#FAFAF5]'}`} data-id="element-67">
            <div className="text-[#333] text-left text-sm pr-2" data-id="element-68">
              {item.situation}
            </div>
            <div className="text-red-main text-center text-[13px]" data-id="element-69">
              {item.without}
            </div>
            <div className="text-green-brand text-center text-[13px] font-semibold" data-id="element-70">
              {item.with}
            </div>
          </div>)}
      </div>

      <p className="text-[clamp(18px,3vw,28px)] text-green-brand font-bold mt-[30px]" data-id="element-71">
        El próximo domingo puede ser diferente.
        <br data-id="element-72" />
        <em className="text-[0.85em] text-brown-light not-italic" data-id="element-73">
          "La tierra te espera. El sistema ya está listo."
        </em>
      </p>
    </section>;
};